var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"title":_vm.displayWithObjectives ? 'CA vs Objectif' : 'CA',"loading":_vm.loading,"colors":_vm.colors,"series":_vm.series,"yAxis":_vm.yAxis,"xAxis":_vm.xAxis,"dags":[
    'partner_get_and_store_daily_dag',
    'partner_get_and_store_daily_ifempty_dag' ]}})}
var staticRenderFns = []

export { render, staticRenderFns }